<template>
  <div class="message-container">
    <h3 class="tab-title">站内信</h3>
    
    <!-- 顶部工具栏 -->
    <div class="message-toolbar">
      <el-button-group>
        <el-button 
          :type="filterMessageType === 1 ? 'primary' : 'default'"
          @click="handleMessageTypeChange(1)"
        >
          收件箱
          <el-badge v-if="unreadCount > 0" :value="unreadCount" class="item" />
        </el-button>
        <el-button 
          :type="filterMessageType === 2 ? 'primary' : 'default'"
          @click="handleMessageTypeChange(2)"
        >
          发件箱
        </el-button>
      </el-button-group>
      
      <div class="toolbar-right">
        <!--el-button 
          type="primary" 
          :disabled="selectedMessages.length === 0"
          @click="batchMarkAsRead"
        >
          标记已读
        </el-button -->
        <el-button 
          type="danger" 
          :disabled="selectedMessages.length === 0"
          @click="batchDelete"
        >
          删除
        </el-button>
        
        <!-- 搜索和筛选 -->
        <el-input
          v-model="searchKeyword"
          placeholder="搜索标题或内容"
          style="width: 200px; margin-left: 10px; "
          clearable
          @clear="handleSearch"
          @keyup.enter="handleSearch"
        >
          <template #prefix>
            <svg t="1787717710786"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1756" width="16" height="16"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6c3.2 3.2 8.4 3.2 11.6 0l43.6-43.5c3.2-3.2 3.2-8.4 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" fill="#1296db" p-id="1757"></path></svg>
          </template>
        </el-input>
        
        <el-button type="primary" @click="handleSearch">
          搜索
        </el-button>
      </div>
    </div>
    
    <!-- 站内信列表 -->
    <div class="message-list">
      <el-table 
        :data="messages" 
        v-loading="loading"
        empty-text="暂无消息"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
        style="width: 1100px; margin: 5px auto 5px auto;"
      >
        <el-table-column type="selection" width="55" />
        
        <el-table-column prop="title" label="标题" width="250">
          <template #default="{ row }">
            <div class="message-title">
              <span v-if="!row.is_read" class="unread-dot"></span>
              <span :class="{ 'unread-title': !row.is_read }">{{ row.title }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="content" label="内容" width="250">
          <template #default="{ row }">
            <div class="message-content">
              {{ getContentPreview(row.content) }}
            </div>
          </template>
        </el-table-column>
        
        <el-table-column prop="sender_username" label="发件人" width="80">
          <template #default="{ row }">
            {{ row.sender_username =='admin'?'平台管理员':row.sender_username }}
          </template>
        </el-table-column>          
        
        <el-table-column prop="created_time" label="发送时间" width="120">
          <template #default="{ row }">
            {{ formatTime(row.created_time) }}
          </template>
        </el-table-column>
        
        <el-table-column prop="read_time" label="阅读时间" width="150">
          <template #default="{ row }">
            <span v-if="row.read_time">{{ formatTime(row.read_time) }}</span>
            <span v-else class="unread-text">未读</span>
          </template>
        </el-table-column>
        
        <el-table-column label="操作">
          <template #default="{ row }">
            <div class="action-buttons">
              <el-button 
                type="text" 
                size="small"
                @click="viewMessageDetail(row)"
              >
                查看
              </el-button>
              
              <!-- 回复按钮：仅对非系统消息显示 -->
              <el-button 
                v-if="row.message_type === 1 && ['ADMIN_MESSAGE', 'REPLY'].includes(row.business_type)"  
                type="text" 
                size="small"
                class="reply-btn"
           
                @click="openReplyDialogFromTable(row)"
              >
                回复
              </el-button>
              
              <el-button 
                type="text" 
                size="small"
                class="delete-btn"
                @click="deleteMessage(row)"
              >
                删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination" v-if="total > 0">
        <el-pagination
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>
    
    <!-- 回复消息弹窗（使用$msgbox替代el-dialog） -->
  </div>
</template>

<script>
import { 
  getMessagesByTenant, 
  getUnreadCount,
  getMessageDetail,
  markAsRead,
  batchMarkAsRead,
  deleteMessage,
  batchDeleteMessages,
  sendMessage
} from '@/api/tenant/message'

export default {
  name: 'MessageList',
  data() {
    return {
      messages: [],
      loading: false,
      
      // 筛选条件
      filterMessageType: 1,
      searchKeyword: '',
      
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      
      // 选中项
      selectedMessages: [],
      
      // 未读数量
      unreadCount: 0,
      
      // 回复相关
      replying: false,
      replyForm: {
        recipient: '',
        title: '',
        content: ''
      },
      currentOriginalMessage: null,
      
      // 用于记录当前正在回复的消息
      replyingMessageId: null
    }
  },
  mounted() {
    this.loadMessages()
    this.loadUnreadCount()
  },
  methods: {
    // 加载消息列表等原有方法保持不变...
    
    // 【核心修复】查看消息详情并自动标记已读
    async viewMessageDetail(message) {
      console.log('查看消息详情:', message)
      
      const loadingInstance = this.$loading({
        lock: true,
        text: '加载消息详情中...',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      try {
        const response = await getMessageDetail(message.id)
        
        if (response.code === 200 && response.data) {
          const detail = response.data
          this.currentOriginalMessage = detail
          
          // 如果消息未读，自动标记为已读
          if (message.isRead === false) {
            await this.markMessageAsRead(message)
            detail.isRead = true
            detail.readTime = new Date().toISOString()
          }
          
          loadingInstance.close()
          
          // 显示消息详情弹框
          this.showMessageDialog(detail)
          
        } else {
          loadingInstance.close()
          this.$message.error(response.message || '获取详情失败')
        }
      } catch (error) {
        loadingInstance.close()
        console.error('查看消息详情失败:', error)
        this.$message.error('加载失败: ' + error.message)
      }
    },
    
    // 显示消息详情弹框（简化版，不带回复按钮）
    showMessageDialog(detail) {
      const h = this.$createElement
      
      const messageContent = h('div', {
        style: {
          maxHeight: '400px',
          overflowY: 'auto',
          padding: '10px'
        }
      }, [
        h('div', {
          style: {
            marginBottom: '15px',
            color: '#666',
            fontSize: '14px',
            lineHeight: '1.8'
          }
        }, [
          h('div', [
            h('strong', '发件人：'),
            detail.senderUsername || '系统'
          ]),
          h('div', [
            h('strong', '发送时间：'),
            this.formatTime(detail.created_time)
          ]),
          detail.readTime && h('div', [
            h('strong', '阅读时间：'),
            this.formatTime(detail.readTime)
          ]),
          detail.businessType && h('div', [
            h('strong', '业务类型：'),
            detail.businessType
          ])
        ].filter(Boolean)),
        
        h('div', {
          style: {
            background: '#f8f9fa',
            padding: '15px',
            borderRadius: '4px',
            borderLeft: '4px solid #409eff',
            whiteSpace: 'pre-wrap',
            lineHeight: '1.6'
          }
        }, detail.content || '无内容')
      ])
      
      this.$msgbox({
        title: detail.title || '消息详情',
        message: messageContent,
        confirmButtonText: '关闭',
        showCancelButton: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: true,
        customClass: 'message-detail-dialog',
        beforeClose: (action, instance, done) => {
          this.loadMessages()
          done()
        }
      }).then(() => {
        console.log('消息详情弹框关闭')
      }).catch(() => {
        this.loadMessages()
      })
    },
    
    // 【新增】从表格行打开回复对话框（使用$msgbox）
    openReplyDialogFromTable(message) {
      console.log('回复消息:', message)
      this.replyingMessageId = message.id
      this.currentOriginalMessage = message
      
      // 使用$msgbox创建回复表单
      this.showReplyDialog(message)
    },
    
    // 显示回复对话框
    showReplyDialog(message) {
      const h = this.$createElement
      
      // 创建回复表单 - 使用原生input和textarea
      const replyForm = h('div', {
        style: {
          padding: '10px 0'
        }
      }, [
        // 收件人 - 纯文本显示
        h('div', {
          style: {
            marginBottom: '16px'
          }
        }, [
          h('div', {
            style: {
              fontSize: '13px',
              color: '#606266',
              marginBottom: '4px'
            }
          }, '收件人'),
          h('div', {
            style: {
              padding: '6px 12px',
              backgroundColor: '#f5f7fa',
              borderRadius: '4px',
              color: '#303133',
              fontSize: '14px',
              border: '1px solid #dcdfe6'
            }
          }, message.senderUsername || '系统')
        ]),
        
        // 标题 - 使用原生input
        h('div', {
          style: {
            marginBottom: '16px'
          }
        }, [
          h('div', {
            style: {
              fontSize: '13px',
              color: '#606266',
              marginBottom: '4px'
            }
          }, '标题'),
          h('input', {
            attrs: {
              type: 'text',
              placeholder: '请输入回复标题',
              value: `回复：${message.title}`
            },
            style: {
              width: '100%',
              padding: '6px 12px',
              fontSize: '14px',
              lineHeight: '1.5',
              color: '#303133',
              backgroundColor: '#fff',
              border: '1px solid #dcdfe6',
              borderRadius: '4px',
              boxSizing: 'border-box',
              outline: 'none'
            },
            on: {
              input: (e) => {
                this.replyForm.title = e.target.value
              }
            }
          })
        ]),
        
        // 内容 - 使用原生textarea
        h('div', {
          style: {
            marginBottom: '10px'
          }
        }, [
          h('div', {
            style: {
              fontSize: '13px',
              color: '#606266',
              marginBottom: '4px'
            }
          }, '内容'),
          h('textarea', {
            attrs: {
              placeholder: '请输入回复内容...',
              rows: 6,
              maxlength: 1000
            },
            style: {
              width: '100%',
              padding: '8px 12px',
              fontSize: '14px',
              lineHeight: '1.5',
              color: '#303133',
              backgroundColor: '#fff',
              border: '1px solid #dcdfe6',
              borderRadius: '4px',
              boxSizing: 'border-box',
              outline: 'none',
              resize: 'vertical',
              minHeight: '120px',
              fontFamily: 'inherit'
            },
            on: {
              input: (e) => {
                this.replyForm.content = e.target.value
                
                // 显示字数统计
                const length = e.target.value.length
                const wordCountEl = document.getElementById('wordCount')
                if (wordCountEl) {
                  wordCountEl.textContent = `${length}/1000`
                }
              }
            }
          }),
          
          // 字数统计
          h('div', {
            attrs: {
              id: 'wordCount'
            },
            style: {
              textAlign: 'right',
              fontSize: '12px',
              color: '#909399',
              marginTop: '4px'
            }
          }, '0/1000')
        ])
      ])
      
      // 初始化回复表单数据
      this.replyForm = {
        recipient: message.senderUsername || '系统',
        title: `回复：${message.title}`,
        content: ''
      }
      
      // 显示回复对话框
      this.$msgbox({
        title: '回复消息',
        message: replyForm,
        showCancelButton: true,
        confirmButtonText: '发送',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        showClose: true,
        customClass: 'reply-message-dialog',
        customStyle: {
          width: '500px',
          maxWidth: '90vw'
        },
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            // 简单验证
            if (!this.replyForm.title.trim()) {
              this.$message.warning('请输入标题')
              return
            }
            if (!this.replyForm.content.trim()) {
              this.$message.warning('请输入内容')
              return
            }
            
            instance.confirmButtonLoading = true
            
            try {
              const success = await this.sendReplyMessage()
              
              if (success) {
                instance.confirmButtonLoading = false
                done()
                this.$message.success('消息发送成功')
                this.loadMessages()
              } else {
                instance.confirmButtonLoading = false
              }
            } catch (error) {
              instance.confirmButtonLoading = false
              console.error('发送失败:', error)
            }
          } else {
            done()
          }
        }
      }).then(action => {
        if (action === 'confirm') {
          console.log('用户点击了发送')
        }
      }).catch(() => {
        console.log('用户取消了回复')
      })
    },
    
    // 发送回复消息
    async sendReplyMessage() {
      this.replying = true
      
      try {
        const messageData = {
          recipient: this.replyForm.recipient,
          title: this.replyForm.title,
          content: this.replyForm.content,
          originalMessageId: this.currentOriginalMessage?.id,
          messageType: 2
        }
        
        const response = await sendMessage(messageData)
        if (response.data.code === 200) {

          this.replying = false;//关闭弹层
          return true
        } else {
          console.log(response.data)
          this.$message.error(response.data.message || '发送失败')
          return false
        }
      } catch (error) {
        console.error('发送消息失败:', error)
        this.$message.error('发送失败: ' + (error.message || '未知错误'))
        return false
      } finally {
        this.replying = false
      }
    },
    
    // 标记消息为已读
    async markMessageAsRead(message) {
      try {
        const response = await markAsRead(message.id)
        if (response.code === 200) {
          console.log('消息自动标记为已读:', message.id)
          this.loadUnreadCount()
          return Promise.resolve()
        } else {
          return Promise.reject(response.message)
        }
      } catch (error) {
        console.error('标记已读失败:', error)
        return Promise.reject(error)
      }
    },
    
    // 工具方法
    formatTime(time) {
      if (!time) return ''
      return new Date(time).toLocaleString('zh-CN')
    },
    
    getContentPreview(content) {
      if (!content) return ''
      return content.length > 50 ? content.substring(0, 50) + '...' : content
    },
    
    // 其他原有方法（loadMessages, loadUnreadCount, batchMarkAsRead, deleteMessage, batchDelete等）保持不变...
    async loadMessages() {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize,
          messageType: this.filterMessageType
        }
        
        if (this.searchKeyword) {
          params.keyword = this.searchKeyword
        }
        
        const response = await getMessagesByTenant(params)
  
        if (response.code === 200 && response.data) {
          this.messages = response.data.data || []
          console.log("this.messages", this.messages)
          this.total = response.data.total || 0
          
          if (this.filterMessageType === 1) {
            this.loadUnreadCount()
          }
        } else {
          this.$message.error(response.message || '加载消息失败')
        }
      } catch (error) {
        console.error('加载消息失败:', error)
        this.$message.error('加载消息失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    
    async loadUnreadCount() {
      try {
        const response = await getUnreadCount()
        if (response.code === 200 && response.data) {
          this.unreadCount = response.data.count || 0
        }
      } catch (error) {
        console.error('加载未读数量失败:', error)
      }
    },
    
    handleMessageTypeChange(type) {
      this.filterMessageType = type
      this.currentPage = 1
      this.selectedMessages = []
      this.loadMessages()
    },
    
    handleSearch() {
      this.currentPage = 1
      this.loadMessages()
    },
    
    handleSelectionChange(selection) {
      this.selectedMessages = selection
    },
    
    handleSortChange() {
      this.loadMessages()
    },
    
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadMessages()
    },
    
    handlePageChange(page) {
      this.currentPage = page
      this.loadMessages()
    },
    
    async batchMarkAsRead() {
      if (this.selectedMessages.length === 0) {
        this.$message.warning('请选择要标记的消息')
        return
      }
      
      try {
        const ids = this.selectedMessages.map(msg => msg.id)
        const response = await batchMarkAsRead(ids)
        
        if (response.code === 200) {
          this.$message.success('批量标记已读成功')
          this.selectedMessages = []
          this.loadMessages()
          this.loadUnreadCount()
        } else {
          this.$message.error(response.message || '批量标记已读失败')
        }
      } catch (error) {
        console.error('批量标记已读失败:', error)
        this.$message.error('批量标记已读失败: ' + (error.message || '未知错误'))
      }
    },
    
    async deleteMessage(message) {
      try {
        await this.$confirm('确定要删除此消息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await deleteMessage(message.id)
        if (response.code === 200) {
          this.$message.success('删除成功')
          this.loadMessages()
          if (this.filterMessageType === 1 && !message.isRead) {
            this.loadUnreadCount()
          }
        } else {
          this.$message.error(response.message || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          this.$message.error('删除失败: ' + (error.message || '未知错误'))
        }
      }
    },
    
    async batchDelete() {
      if (this.selectedMessages.length === 0) {
        this.$message.warning('请选择要删除的消息')
        return
      }
      
      try {
        await this.$confirm(`确定要删除选中的${this.selectedMessages.length}条消息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const ids = this.selectedMessages.map(msg => msg.id)
        const response = await batchDeleteMessages(ids)
        
        if (response.code === 200) {
          this.$message.success('批量删除成功')
          this.selectedMessages = []
          this.loadMessages()
          this.loadUnreadCount()
        } else {
          this.$message.error(response.message || '批量删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('批量删除失败:', error)
          this.$message.error('批量删除失败: ' + (error.message || '未知错误'))
        }
      }
    }
  }
}
</script>

<style scoped>
.message-container {
  padding: 20px;
}

.message-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.message-title {
  display: flex;
  align-items: center;
}

.unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #f56c6c;
  border-radius: 50%;
  margin-right: 8px;
}

.unread-title {
  font-weight: bold;
}

.message-content {
  color: #606266;
}

.unread-text {
  color: #f56c6c;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

.reply-btn {
  color: #67c23a;
}

.delete-btn {
  color: #f56c6c;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>

<style>
/* 自定义弹框样式 */
.message-detail-dialog,
.reply-message-dialog {
  width: 600px !important;
  max-width: 90vw !important;
}
.reply-message-dialog .el-message-box {
  width: 100% !important;
  max-height: 70vh !important;
  display: flex;
  flex-direction: column;
}
.message-detail-dialog .el-message-box__content,
.reply-message-dialog .el-message-box__content {
  padding: 20px !important;
  max-height: calc(70vh - 120px);
  overflow-y: auto;
}

.message-detail-dialog .el-message-box__header,
.reply-message-dialog .el-message-box__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
  flex-shrink: 0;
}

.message-detail-dialog .el-message-box__title,
.reply-message-dialog .el-message-box__title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.message-detail-dialog .el-message-box__message,
.reply-message-dialog .el-message-box__message {
  padding: 0 !important;
  width: 100%;
}

.message-detail-dialog .el-message-box__btns,
.reply-message-dialog .el-message-box__btns {
  padding: 16px 24px;
  border-top: 1px solid #ebeef5;
  flex-shrink: 0;
}
.reply-message-dialog .el-message-box__btns button {
  min-width: 80px;
}
/* 确保弹框显示在最上层 */
.el-overlay {
  z-index: 9999 !important;
}

/* 回复对话框表单样式 */
.reply-message-dialog .el-form-item {
  margin-bottom: 16px;
}

.reply-message-dialog .el-input__inner,
.reply-message-dialog .el-textarea__inner {
  min-height: 180px;
  resize: vertical;
}
.reply-message-dialog .el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  color: #909399;
}
/* 滚动条样式 */
.reply-message-dialog .el-message-box__content::-webkit-scrollbar {
  width: 6px;
}

.reply-message-dialog .el-message-box__content::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 3px;
}

.reply-message-dialog .el-message-box__content::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 3px;
}

.reply-message-dialog .el-message-box__content::-webkit-scrollbar-thumb:hover {
  background: #a8abb2;
}

/* 确保弹框显示在最上层 */
.el-overlay {
  z-index: 9999 !important;
}

/* 消息详情弹框样式保持不变 */
.message-detail-dialog {
  max-width: 700px;
}

.message-detail-dialog .el-message-box__content {
  padding: 0;
}

.message-detail-dialog .el-message-box__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}

.message-detail-dialog .el-message-box__title {
  font-size: 18px;
  font-weight: 600;
}

.message-detail-dialog .el-message-box__message {
  padding: 0;
}

.message-detail-dialog .el-message-box__btns {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
}
/* 原生输入框的聚焦样式 */
.reply-message-dialog input:focus,
.reply-message-dialog textarea:focus {
  border-color: #409eff !important;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 输入框悬停效果 */
.reply-message-dialog input:hover,
.reply-message-dialog textarea:hover {
  border-color: #c0c4cc;
}

/* 确保弹框显示在最上层 */
.el-overlay {
  z-index: 9999 !important;
}

/* 消息详情弹框样式保持不变 */
.message-detail-dialog {
  max-width: 700px;
}

.message-detail-dialog .el-message-box__content {
  padding: 0;
}

.message-detail-dialog .el-message-box__header {
  padding: 16px 20px;
  border-bottom: 1px solid #ebeef5;
}

.message-detail-dialog .el-message-box__title {
  font-size: 18px;
  font-weight: 600;
}

.message-detail-dialog .el-message-box__message {
  padding: 0;
}

.message-detail-dialog .el-message-box__btns {
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
}
.icon{
  margin-top: 8px;
}
</style>